import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function DeleteConfirmModal({ game, onClose, onConfirm }) {
  if (!game) return null;
  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={(e) => e?.target === e?.currentTarget && onClose()}
    >
      <div
        className="w-full max-w-sm rounded-2xl overflow-hidden animate-bounce-in"
        style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', boxShadow: 'var(--shadow-xl)' }}
      >
        <div className="p-6 flex flex-col items-center gap-4 text-center">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(239,68,68,0.1)' }}>
            <Icon name="Trash2" size={28} color="var(--color-error)" />
          </div>
          <div>
            <h2 className="text-base font-bold mb-1" style={{ color: 'var(--color-foreground)', fontFamily: 'var(--font-heading)' }}>Delete Game?</h2>
            <p className="text-sm" style={{ color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-caption)' }}>
              Are you sure you want to delete <strong>"{game?.title}"</strong>? This action cannot be undone.
            </p>
          </div>
          <div className="flex gap-3 w-full">
            <Button variant="outline" onClick={onClose} className="flex-1">Cancel</Button>
            <Button variant="destructive" onClick={() => { onConfirm(game); onClose(); }} iconName="Trash2" iconPosition="left" className="flex-1">
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}